export const defaultBlogField = [
  "image",
  "title",
  "blogcategory",
  "createdAt",
  "comment_count",
  "active",
];

export const defaultBlogCategoryField = [
  "parent_category",
  "description",
  "blog_count",
  "action",
];

export const defaultBlogCommentsField = [
  "image",
  "title",
  "comment_count",
  "action",
];

export const BLOG_SORT_KEYS = [
  "title",
  "blogcategory",
  "comment_count",
  "active",
  "blog_publish_date",
  "createdAt",
];

export const BLOG_COMMENTS_SORT_KEYS = [
  "title",
  "comment_count",
  "createdAt",
];